export default "/_next/static/images/book-demo-background-474a32b60b844c12f22a6fb2cb5f299b.svg";